import React from 'react';
import { CheckCheckIcon, MoreVerticalIcon, PaperclipIcon, PhoneIcon, SmileIcon, VideoIcon } from 'lucide-react';
import type { WhatsAppChat as Chat } from '../data/whatsappChats';
export function WhatsAppChat({
  chat
}: {
  chat: Chat;
}) {
  return <article className="flex h-full w-full flex-col overflow-hidden rounded-md border border-ink-500 bg-[#0B141A]" data-id="element-199" data-mp="1oebklpmuqtod">
      <header className="flex items-center gap-3 bg-[#1F2C33] px-4 py-3" data-id="element-200" data-mp="1jf8lsmxgtjou">
        <img src={chat.avatar} alt={`Foto de perfil de ${chat.name}, coach de pádel`} className="h-10 w-10 rounded-full object-cover" data-id="element-201" data-mp="1ejb7em5rinep" />
        <div className="min-w-0 flex-1" data-id="element-202" data-mp="15iczvtw47xrd">
          <p className="truncate text-sm font-semibold text-white" data-id="element-203" data-mp="15jef8ak5z6ew">{chat.name}</p>
          <p className="truncate text-xs text-[#8696A0]" data-id="element-204" data-mp="10k1rlnlgxvb9">{chat.status}</p>
        </div>
        <div className="flex items-center gap-3 text-[#8696A0]" aria-hidden="true" data-id="element-205" data-mp="2zut3emxj0xsj">
          <VideoIcon className="h-4 w-4" data-id="element-206" data-mp="2ux9r3ske2v38" />
          <PhoneIcon className="h-4 w-4" data-id="element-207" data-mp="2uuf5vytjx68r" />
          <MoreVerticalIcon className="h-4 w-4" data-id="element-208" data-mp="cb37bg0fy8n5" />
        </div>
      </header>

      <div className="flex flex-1 flex-col gap-2 bg-[#0B141A] px-3 py-4" data-id="element-209" data-mp="gcoi8vtf0cup">
        <p className="mx-auto rounded bg-[#182229] px-3 py-1 text-[11px] font-medium uppercase tracking-wide text-[#8696A0]" data-id="element-210" data-mp="gatxbhi58kqm">
          Hoy
        </p>

        {chat.messages.map((message, index) => {
        const isMe = message.from === 'me';
        return <div key={`${message.time}-${index}`} className={`flex ${isMe ? 'justify-end' : 'justify-start'}`} data-id="element-211" data-mp="v2cj5vxop9hw" data-mpi={index}>
              <div className={`max-w-[85%] rounded-lg px-3 py-2 text-[13px] leading-snug ${isMe ? 'rounded-tr-none bg-[#005C4B] text-white' : 'rounded-tl-none bg-[#202C33] text-slate-100'}`} data-id="element-212" data-mp="lcascwdy5cza">
                <p data-id="element-213" data-mp="1ir58vanpql42">{message.text}</p>
                <span className="mt-1 flex items-center justify-end gap-1 text-[10px] text-[#8696A0]" data-id="element-214" data-mp="1is6ta5qmcjyg">
                  {message.time}
                  {isMe && <CheckCheckIcon className="h-3 w-3 text-[#53BDEB]" aria-hidden="true" data-id="element-215" data-mp="1noaxat0hu8q5" />}
                </span>
              </div>
            </div>;
      })}
      </div>

      <footer className="flex items-center gap-2 bg-[#1F2C33] px-3 py-3" aria-hidden="true" data-id="element-216" data-mp="1iraqugzqf3yi">
        <SmileIcon className="h-5 w-5 shrink-0 text-[#8696A0]" data-id="element-217" data-mp="1encnfu3dj6zn" />
        <span className="flex-1 truncate rounded-full bg-[#2A3942] px-3 py-2 text-xs text-[#8696A0]" data-id="element-218" data-mp="19pky97u45yz5">
          Escribe un mensaje
        </span>
        <PaperclipIcon className="h-5 w-5 shrink-0 text-[#8696A0]" data-id="element-219" data-mp="14vzxx951ssws" />
      </footer>
    </article>;
}